var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ado-logo"},[_vm._v(" ADO"),_c('span',{staticClass:"pi primary--text"},[_vm._v("PI")]),_vm._v("SOFT ")])
}]

export { render, staticRenderFns }